import { render, staticRenderFns } from "./DragAndDropDesktop.vue?vue&type=template&id=b04f39ce&scoped=true"
import script from "./DragAndDropDesktop.vue?vue&type=script&lang=js"
export * from "./DragAndDropDesktop.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropDesktop.vue?vue&type=style&index=0&id=b04f39ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04f39ce",
  null
  
)

export default component.exports